import { css, Theme } from '@emotion/react'

export const switchLabel = (theme: Theme) => css`
  .MuiFormControlLabel-label {
    color: ${theme.colors.typographyTwo};
    font-weight: 600;
    margin-right: 10px;
  }
`
